module.exports = __webpack_public_path__ + "static/media/31JFA7.afd65c0a.jpg";